import { disableBodyScroll as e, enableBodyScroll as n, clearAllBodyScrollLocks as s } from "body-scroll-lock";
let t = {};
const c = (l, o = t) => e(l, o), r = (l) => n(l), S = () => s(), i = {
  mounted(l, { value: o }) {
    o && c(l);
  },
  updated(l, { value: o }) {
    o ? c(l) : r(l);
  },
  beforeUnmount(l) {
    r(l);
  }
}, a = {
  install(l, o) {
    t = o, l.directive("scroll-lock", i);
  }
};
export {
  a as default,
  c as lockScroll,
  S as unlockAllScrolls,
  r as unlockScroll
};
